import LoadIndicator from 'devextreme-react/load-indicator';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import { useAuth } from '../../contexts/auth';
import { LoginAction } from '../../store/action/userAction';
import useSearchParams from '../../hooks/useSearchParams';

const OAuthCallback = (): JSX.Element => {
  const loading = useAuth();
  const history = useHistory();
  const dispatch = useDispatch();
  const searchParams = useSearchParams();

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const verifier = sessionStorage.getItem('verifier');

    if (code != null && state != null && verifier != null) {
      const data = {
        code: code,
        state: state,
        redirectUri: process.env.REACT_APP_ONYX_OAUTH_CALLBACK_URI,
        codeVerifier: verifier,
      };

      dispatch(LoginAction('users/authenticateoauth', data));
    }

    history.replace('/login');
  }, [searchParams, dispatch, history]);

  return (
    <div className="d-flex justify-content-center align-items-center mx-auto ">
      {!loading ? (
        <div className="d-flex flex-column justify-content-center align-items-center">
          <LoadIndicator width={'48px'} height={'48px'} visible={true} />
          <span className="my-3">Signing in with SSO</span>
        </div>
      ) : (
        <Redirect to="/login" />
      )}
    </div>
  );
};

OAuthCallback.displayName = 'SSO';
export default OAuthCallback;
